if (typeof define === "function" && define.amd) {
    define('Controls/ContentUrlReplace',[], function () {
        
        function ContentUrlReplace(container) {
            this.replaceList = ['h1-title','h1-subtitle','set_url_param_1','set_url_param_2','set_url_param_3','set_url_param_4'];
        }
        
        ContentUrlReplace.prototype.execute = function () {
            if(location.search.length>1) {
                var allParams = location.search.substr(1).split('&');
                for (var i = 0; i < allParams.length; i++) {
                    var param = allParams[i].split('=');
                    if (this.replaceList.indexOf(param[0]) > -1) {
                        $('.'+param[0]).html(decodeURI(param[1]));
                    }
                }
            }
        };

        return ContentUrlReplace;
    });
};
